<template>
  <b-container fluid class="login-page pt-5">
    <b-col cols="12" lg="6" xl="4" offset-lg="3" offset-xl="4">
      <Notification v-bind.sync="notification" />
    </b-col>
    <div class="d-flex justify-content-center">
      <b-card class="login-card rounded-0 shadow">
        <b-card-title class="d-flex justify-content-center py-3">
          Online Timesheet Login
        </b-card-title>
        <b-form>
          <b-form-group
            id="username_grp"
            label-for="email_input"
          >
            <b-form-input
              id="email_input"
              type="text"
              placeholder="Email"
              aria-describedby="username_feedback"
              class="mx-auto no-outline border-dark rounded-0 input"
              v-model="formObject.email"
              :state="inputValid.email"
              @keypress.enter="onClickLogin"
              trim
            />
            <b-form-invalid-feedback id="username_feedback" class="mx-auto">
              Please provide your email.
            </b-form-invalid-feedback>
          </b-form-group>

          <b-form-group id="password_grp" label-for="password_input">
            <b-form-input
              id="password_input"
              type="password"
              placeholder="Password"
              aria-describedby="password_feedback"
              class="mx-auto no-outline border-dark rounded-0 input"
              v-model="formObject.password"
              :state="inputValid.password"
              @keypress.enter="onClickLogin"
              trim
            ></b-form-input>
            <b-form-invalid-feedback id="password_feedback" class="mx-auto">
              Please provide your password.
            </b-form-invalid-feedback>
          </b-form-group>
          <b-link :to="{ name: 'forgot-password' }" class="forgot-pass mb-4">
            <span>Forgot password?</span>
          </b-link>
          <b-button-toolbar>
            <b-button
              v-if="googleLoginEnabled"
              :disabled="isLoadingPage"
              @click="onCLickLoginGoogle"
              variant="dark"
              class="ml-auto mr-1"
            >
              <v-icon
                name="brands/google"
                scale="1"
              />

            </b-button>
            <b-button
              block
              :disabled="isLoadingPage"
              @click="onClickLogin"
              variant="outline-dark"
              :class="{
                'mr-auto login-btn': googleLoginEnabled,
                'mx-auto login-btn': !googleLoginEnabled,
              }"
            >
              Login
            </b-button>
          </b-button-toolbar>
        </b-form>
      </b-card>
    </div>
  </b-container>
</template>
<script>
import { mapGetters, mapActions, mapState } from 'vuex';
import auth from '@/mixins/auth';
import Notification from '@/components/Notification';

export default {
  name: 'Login',
  mixins: [auth],
  components: {
    Notification,
  },
  data() {
    return {
      inputValid: {
        email: null,
        password: null,
      },
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      const { sessionTimeout } = to.query;
      const notificationOptions = sessionTimeout ? {
        show: 10,
        variant: 'danger',
        message: 'Login session timed out',
        dismissible: true,
        icon: {
          name: 'hourglass',
        },
      } : {};

      vm.$store.dispatch('setNotification', notificationOptions);

      if (sessionTimeout) {
        vm.logout();
        return;
      }

      // if already logged in, redirect to homepage
      if (vm.isLoggedIn) {
        vm.stopLoadingPage();
        vm.$store.dispatch('resetNotification');
        vm.$router.push({ name: 'home' });
      }
    });
  },
  computed: {
    googleLoginEnabled() {
      return false;
    },
    ...mapState(['notification']),
    ...mapGetters(['formObject', 'isLoadingPage', 'isLoggedIn']),
  },
  methods: {
    onCLickLoginGoogle() {
      // TODO:
      // eslint-disable-next-line
      console.log('google auth');
    },
    onClickLogin() {
      const { email, password } = this.formObject;

      this.resetErrors();
      if (email && password) {
        this.authLogin(email, password);
      }
      if (!email) {
        this.setError('email');
      }
      if (!password) {
        this.setError('password');
      }
    },
    setError(field) {
      this.inputValid[field] = false;
    },
    resetErrors() {
      Object.keys(this.inputValid).forEach((key) => {
        this.inputValid[key] = null;
      });
    },
    ...mapActions([
      'setFormObject',
      'setNotification',
      'stopLoadingPage',
      'logout',
    ]),
  },
};
</script>
<style lang="scss" scoped>
.login-page {
  // padding-top: 30px;

  .login-card {
    max-width: 30rem;
    width: 100%;
  }

  .login-btn {
    max-width: 10em;
  }

  .forgot-pass {
    display: inline-block;
    font-size: 1rem;
    margin-left: 30px;
  }

  #email,
  #username,
  #password {
    &_input,
    &_feedback {
      max-width: 85%;
    }
  }
}
</style>
